/* LUNEVO V2 — Sécurisation des semelles offertes, par pointure.
   Une paire LUNEVO WDG = une paire de semelles gratuites de même pointure.
   Les prix et remises restent calculés par Shopify. */
(() => {
  'use strict';
  if (window.__lunevoFleeceV2Loaded) return;
  window.__lunevoFleeceV2Loaded = true;

  const SHOE_PRODUCT = 15784068546886;
  const FREE_VARIANT = 57746433933638;
  const DUO_GIFT_PRODUCT = 15828633682246;
  const DUO_GIFT_START = Date.parse('2026-11-04T00:30:00+01:00');
  const DUO_GIFT_END = Date.parse('2026-11-07T00:30:00+01:00');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = (name) => root.replace(/\/?$/, '/') + (name ? 'cart/' + name + '.js' : 'cart.js');
  let running = false;
  let rerun = false;
  let refreshed = false;

  function sizeOf(value) {
    const match = String(value || '').match(/(?:^|[^0-9])(?:EU\s*)?(3[7-9]|4[0-5])(?=$|[^0-9])/i);
    return match ? match[1] : null;
  }

  function shoeSize(item) {
    const opts = item.options_with_values || [];
    const named = opts.find((o) => /koko|size/i.test(String(o.name)));
    const raw = (named && named.value) ||
      (item.variant_options && item.variant_options[1]) ||
      (item.options && item.options[1]) ||
      String(item.variant_title || '').split('/').pop();
    return sizeOf(raw);
  }

  async function request(endpoint, options) {
    const response = await fetch(url(endpoint), Object.assign({
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }, options || {}));
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error('LUNEVO cart: ' + (data.description || data.message || response.status));
    return data;
  }

  function mismatch(cart) {
    // LUNEVO V4 : anciennes lignes de gants tarifés issues du test BXGY.
    // Elles doivent disparaître sans toucher aux gants vendus normalement.
    for (const item of cart.items || []) {
      if (item.properties && item.properties._lunevo_campaign_gift === '1') {
        return { action: 'change', key: item.key, quantity: 0 };
      }
    }

    // Cadeau DUO indépendant des remises Shopify : le prix de ce produit
    // caché est réellement 0 € ; on ne garde que 2 paires pour 2 chaussures.
    const shoeQty = (cart.items || []).reduce((qty, item) =>
      qty + (Number(item.product_id) === SHOE_PRODUCT ? Number(item.quantity) : 0), 0);
    const now = Date.now();
    let giftAllowance = shoeQty >= 2 && now >= DUO_GIFT_START && now < DUO_GIFT_END ? 2 : 0;
    for (const item of cart.items || []) {
      if (Number(item.product_id) !== DUO_GIFT_PRODUCT) continue;
      const isCampaignGift = Boolean(item.properties && item.properties._lunevo_duo_gift_0 === '1');
      const desired = isCampaignGift ? Math.min(Number(item.quantity), giftAllowance) : 0;
      giftAllowance -= desired;
      if (desired !== Number(item.quantity)) {
        return { action: 'change', key: item.key, quantity: desired };
      }
    }

    const needed = new Map();
    const gifts = [];
    for (const item of cart.items || []) {
      if (Number(item.product_id) === SHOE_PRODUCT) {
        const size = shoeSize(item);
        if (size) needed.set(size, (needed.get(size) || 0) + Number(item.quantity));
      } else if (Number(item.variant_id) === FREE_VARIANT) {
        gifts.push(item);
      }
    }
    for (const item of gifts) {
      const size = sizeOf(item.properties && item.properties.Koko);
      const available = size ? (needed.get(size) || 0) : 0;
      const keep = Math.min(Number(item.quantity), available);
      if (size) needed.set(size, available - keep);
      if (keep !== Number(item.quantity)) {
        return { action: 'change', key: item.key, quantity: keep };
      }
    }
    for (const [size, quantity] of needed.entries()) {
      if (quantity > 0) return { action: 'add', size, quantity };
    }
    return null;
  }

  async function reconcile() {
    if (running) { rerun = true; return; }
    if (refreshed) return;
    running = true;
    let modified = false;
    try {
      // Recompute after each mutation: Shopify may change cart line keys.
      for (let i = 0; i < 20; i++) {
        const cart = await request('');
        const fix = mismatch(cart);
        if (!fix) break;
        if (fix.action === 'change') {
          await request('change', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: fix.key, quantity: fix.quantity })
          });
        } else {
          await request('add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: FREE_VARIANT,
                quantity: fix.quantity,
                properties: { Koko: 'EU ' + fix.size }
              }]
            })
          });
        }
        modified = true;
      }
      if (modified) {
        refreshed = true;
        window.location.reload(); // Refresh price, cart and discount sections together.
      }
    } catch (error) {
      console.error('LUNEVO V2 — synchronisation semelles offerte:', error);
    } finally {
      running = false;
      if (rerun && !refreshed) { rerun = false; reconcile(); }
    }
  }

  function init() {
    if (/\/cart\/?$/.test(window.location.pathname) ||
        document.querySelector('cart-drawer-items:not(.is-empty)')) {
      reconcile();
    }
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcile());
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
